import MedicalAssistantsContainer from './medical-assistants-container';

export default MedicalAssistantsContainer;
